import { createSelector } from "reselect";
import * as actionTypes from "constants/actionTypes";

const initialState = {
  synced: false,
  segments: {}
};

export default function segments(state = initialState, action) {
  switch (action.type) {
    case actionTypes.UPDATE_SEGMENT_IN_STORE:
      return {
        ...state,
        segments: {
          ...state.segments,
          [action.payload.segmentId]: {
            ...state.segments[action.payload.segmentId],
            ...action.payload.changes
          }
        }
      };
    case actionTypes.REPLACE_ACCOUNT_SEGMENT: {
      if (action.payload.segment) {
        return {
          ...state,
          segments: {
            ...state.segments,
            [action.payload.segmentId]: action.payload.segment
          }
        };
      }
      const {
        [action.payload.segmentId]: omit,
        ...segmentsWithoutSegment
      } = state.segments;
      return { ...state, segments: segmentsWithoutSegment };
    }
    case actionTypes.REPLACE_ACCOUNT_SEGMENTS:
      return {
        synced: true,
        segments: action.payload
      };
    case actionTypes.DELETE_SEGMENT_IN_STORE: {
      const {
        [action.payload.segmentId]: omit,
        ...stateWithoutSegment
      } = state.segments;
      return { ...state, segments: stateWithoutSegment };
    }
    case actionTypes.CLEAR_ACCOUNT_DATA:
      return initialState;
    default:
      return state;
  }
}

export const selectAccountSegments = state => state.account.segments.segments;
export const selectAccountSegment = (state, segmentId) =>
  selectAccountSegments(state)[segmentId];
export const selectAccountSegmentsSynced = state =>
  state.account.segments.synced;
export const selectLifecycleSegment = (state, userLifecycleStage) =>
  Object.values(selectAccountSegments(state)).find(
    ({ meta }) => meta && meta.userLifecycleStage === userLifecycleStage
  );
export const selectAccountSegmentsDigest = createSelector(
  [selectAccountSegments],
  segments => {
    return Object.keys(segments || {}).reduce((acc, segmentId) => {
      const { id, name, meta = {} } = segments[segmentId];
      acc[segmentId] = {
        id,
        name,
        meta
      };
      return acc;
    }, {});
  }
);
